import request from "@/utils/request.js";
class Api {
  // 首页-实时统计数据
  list(data) {
    return request({
      method: "post",
      url: "/stat/recall",
      data,
    });
  }
}
export default new Api();
